import { render } from "./partB.vue?vue&type=template&id=7a2240f2"
import script from "./partB.vue?vue&type=script&lang=js"
export * from "./partB.vue?vue&type=script&lang=js"

import "./partB.vue?vue&type=style&index=0&id=7a2240f2&lang=css"

import exportComponent from "C:\\WorkSpace\\webapp\\vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__